import { useMutation } from "@apollo/client/react";
import { mutations } from "@/graphql";
import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

const VERIFY_USER_TOKEN = mutations.verifyUserByToken;

// export function useVerifyUserByToken(
//   onCompleted = () => {},
//   onError = () => {}
// ) {
//   const [comVerifyUserByToken, { loading }] = useMutation<any>(VERIFY_USER_TOKEN, {
//     onCompleted: () => {
//       onCompleted();
//     },
//     onError: () => {
//       onError();
//     }
//   });
//   const verify = useCallback(
//     ({ token }) => {
//       comVerifyUserByToken({
//         variables: {
//           token: token?.replaceAll(" ", "+")
//           // token: token?.replaceAll(" ", "+")
//         }
//       });
//     },
//     [comVerifyUserByToken]
//   );

//   return {
//     verify,
//     loading
//   };
// }
/**
 *
 * @param onError
 */
export function useVerifyUserByToken(
  // onCompleted = () => null,
  onError: (error?: any) => void = () => null,
) {
  const [isConfirmed, setIsConfirmed] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [comVerifyUserByToken, { loading }] = useMutation<any>(
    VERIFY_USER_TOKEN,
    {
      onCompleted: (data) => {
        const res = data?.verifyUserByToken || data?.comVerifyUserByToken;
        if (res?.success === true) {
          setIsConfirmed(true);
          setEmail(res.email);
        } else if (res?.success === false) {
          setIsConfirmed(false);
          enqueueSnackbar(res.message || "Invalid or expired token", {
            variant: "error",
          });
          navigate("/auth/login");
        }
      },
      onError: (error) => {
        setIsConfirmed(false);
        onError(error);
      },
    },
  );

  const verify = useCallback(
    (token: string | undefined) => {
      comVerifyUserByToken({
        variables: {
          token: token?.replace(/ /g, "+"),
          // token: token?.replaceAll(" ", "+")
        },
      });
    },
    [comVerifyUserByToken],
  );

  return {
    verify,
    loading,
    isConfirmed,
    email,
  };
}
